module.exports = __webpack_public_path__ + "ac7f7242ddcc18f55266ec380f7ff5e2.png";